import React from 'react';
import './Dragger.scss';

export const Dragger = () => {
	return <i className="fa fa-bars mobile-artwork-toggle-dragger" />;
};
